module.exports = __webpack_public_path__ + "static/media/tents.f9d11846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/tents.jpg
// module id = 174
// module chunks = 0